"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/onboardingShared/OnboardingDownloadModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');



var _onboardingAnalytics = require('web/services/onboardingAnalytics');


var _SecondaryDownloads = require('web/screens/Signup/Setup/Sections/Finish/components/SecondaryDownloads'); var _SecondaryDownloads2 = _interopRequireDefault(_SecondaryDownloads);
var _onboardingShared = require('web/screens/onboardingShared');

/**
 * The post-onboarding app-download prompt, rendered over the inbox as a
 * dismissible modal after a self-serve cohort finishes onboarding — replacing the
 * old terminal "download the app" screen. The user always lands in the working
 * inbox; this surfaces the same platform-aware download UI (`SecondaryDownloads`)
 * as the pre-login finish screen, once.
 *
 * The terminal finish legs (`useOnboardingFinishToInbox` and the
 * `OnboardingPayment` success / skip legs) arm a one-shot sessionStorage flag
 * just before `gotoInbox`; this consumes it on mount, so a reload never re-shows
 * the prompt. Closing (X / Esc / backdrop) or "Done" dismisses it.
 */
const OnboardingDownloadModal = () => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  // The consume must happen exactly once even under a dev double-mount, since it
  // clears the flag; a ref gate makes it idempotent.
  const consumedRef = _react.useRef.call(void 0, false)
  const hasTrackedView = _react.useRef.call(void 0, false)

  const platform = _react.useMemo.call(void 0, () => _SecondaryDownloads.computePlatformInfo.call(void 0, ), [])

  _react.useEffect.call(void 0, () => {
    if (consumedRef.current) return
    consumedRef.current = true
    if (_onboardingShared.consumeShowDownloadModal.call(void 0, )) setIsOpen(true)
  }, [])

  // Emit the prompt-viewed event once, when the modal actually opens (mirrors the
  // pre-login finish screen's app_download_prompt_viewed).
  _react.useEffect.call(void 0, () => {
    if (!isOpen || hasTrackedView.current) return
    hasTrackedView.current = true
    _onboardingAnalytics.captureOnboardingEvent.call(void 0, _onboardingAnalytics.ONBOARDING_EVENTS.APP_DOWNLOAD_PROMPT_VIEWED, {
      app_mode: platform.appMode,
      platform: 'web',
      surface: 'onboarding_inbox',
    })
  }, [isOpen, platform.appMode])

  if (!isOpen) return null

  const subtitle = platform.isMobileBrowser
    ? 'Open BloomText on your phone to start messaging.'
    : (platform.isElectron || !platform.hasDesktopInstaller)
        ? 'Get BloomText on your phone too.'
        : 'Download BloomText for the best experience.'

  const onClose = () => setIsOpen(false)

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: "You're all set!"  ,
      className: "onboarding-download-modal",
      bodyClassName: "onboarding-download-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 64}}

      , _react2.default.createElement('p', { className: "onboarding-download-modal--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}},  subtitle )
      , _react2.default.createElement(_SecondaryDownloads2.default, { surface: "onboarding_inbox", layout: "stacked", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}} )
       /* Beside the store button, Done steps back to a secondary action. */ 
      , _react2.default.createElement(_Form.Button, {
        onClick: onClose,
        isInverted: platform.isMobileBrowser,
        className: "onboarding-download-modal--done", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}
, "Done"

      )
    )
  )
}

exports. default = OnboardingDownloadModal
